import { bool, number, shape, string } from "prop-types";

/** @deprecated use TypeScript interface or type instead */
export const baseUploadType = {
  id: string,
  name: string,
  contentType: string,
  filePath: string,
  isDeleted: bool,
  partitionKey: string,
  _ts: number,
};

/** @deprecated use TypeScript interface or type instead */
export const projectImageUploadFileType = shape({
  ...baseUploadType,
  projectId: string,
  isDefaultImage: bool,
  url: string,
  uid: string.isRequired,
});
